import React from 'react';
import { Info } from 'lucide-react';
import { Panel } from '../../common/Panel';
import { InfoItem } from '../../common/InfoItem';
import { ReviewChecklistPanel } from './ReviewChecklistPanel';
import { useApplicationReview } from '../../../contexts/ApplicationReviewContext';
import { can } from '../../../utils/applicationQueue';
import { vehicleChecklist, vehicleInfo } from '../../../utils/applicationRecords';
import type { OwnerApplication } from '../../../types/owner';
export function VehicleReviewTab({
  app
}: {
  app: OwnerApplication;
}) {
  const {
    getReview,
    updateReview,
    addHistory,
    role
  } = useApplicationReview();
  const r = getReview(app);
  const v = vehicleInfo(app);
  const cng = app.vehicleType === 'cng';
  const items = vehicleChecklist(app);
  const editable = can(role, 'review') || can(role, 'validate');
  return <div className="grid gap-4 xl:grid-cols-5" data-id="element-670" data-mp="1f07gxkc3fm6z">
      <div className="space-y-4 xl:col-span-3" data-id="element-671" data-mp="1ayu9x6x9lcyh">
        {!cng && <p className="flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-800" data-id="element-672" data-mp="1b0oycv7qvn7b">
            <Info className="h-4 w-4 shrink-0" data-id="element-673" data-mp="368t280xx79ca" />মোটরসাইকেল আবেদন — ফিটনেস সার্টিফিকেট ও রুট পারমিট প্রযোজ্য নয়; ফিল্ড ও চেকলিস্ট স্বয়ংক্রিয়ভাবে সমন্বয় করা হয়েছে।
          </p>}
        <div className="grid gap-4 md:grid-cols-2" data-id="element-674" data-mp="3fyvt9vlhed7z">
          <Panel title="গাড়ির মৌলিক তথ্য" bodyClassName="p-0" data-id="element-675" data-mp="3g0qgjgk86hf8">
            <img src={v.image} alt={app.vehicleReg} className="h-36 w-full object-cover" data-id="element-676" data-mp="3kz07tg2twxvk" />
            <dl className="grid gap-x-4 gap-y-3.5 p-4 sm:grid-cols-2" data-id="element-677" data-mp="3ozaobmo8z6oo">
              <InfoItem label="রেজিস্ট্রেশন" value={app.vehicleReg} data-id="element-678" data-mp="3tyx4a3vgn116" />
              <InfoItem label="ধরন" value={v.typeLabel} data-id="element-679" data-mp="3tzq22fcfyg76" />
              <InfoItem label="ব্র্যান্ড" value={v.brand} data-id="element-680" data-mp="2svoxj4gpl9q" />
              <InfoItem label="মডেল" value={v.model} data-id="element-681" data-mp="2q9ijmtb5bt3" />
              <InfoItem label="রং" value={v.color} data-id="element-682" data-mp="1zlxi1rwkr8kx" />
              <InfoItem label="তৈরির সাল" value={v.year} data-id="element-683" data-mp="24jz0cam6f3vc" />
            </dl>
          </Panel>
          <Panel title="প্রকৌশল ও বৈধতার তথ্য" data-id="element-684" data-mp="24ltlnq1d0xzy">
            <dl className="grid gap-y-3.5" data-id="element-685" data-mp="1wkc6a6rcwaeb">
              <InfoItem label="চেসিস" value={app.chassis} mono data-id="element-686" data-mp="1wl44lpcc8m8a" />
              <InfoItem label="ইঞ্জিন" value={app.engine} mono data-id="element-687" data-mp="1sj0ouoimyvh7" />
              <InfoItem label="জ্বালানি" value={v.fuel} data-id="element-688" data-mp="26i0455k9dy0p" />
              <InfoItem label="নিবন্ধনের তারিখ" value={v.regDate} data-id="element-689" data-mp="26fdw74tghghy" />
              {cng && <InfoItem label="ফিটনেস মেয়াদ" value={v.fitnessExpiry} data-id="element-690" data-mp="21hm2q6d5xmbn" />}
              <InfoItem label="ট্যাক্স টোকেন" value={v.taxExpiry} data-id="element-691" data-mp="2fhdfk3ry0wo2" />
              {cng && <InfoItem label="রুট পারমিট" value={v.routeExpiry} data-id="element-692" data-mp="2bgjudi5vxvyv" />}
            </dl>
          </Panel>
        </div>
      </div>
      <div className="xl:col-span-2" data-id="element-693" data-mp="2p883rdor26c5">
        <ReviewChecklistPanel title="যাচাই চেকলিস্ট — গাড়ি" items={items} checks={r.vehicleChecks} result={r.vehicleResult} disabled={!editable} onChange={c => updateReview(app, {
        vehicleChecks: c
      })} onResult={res => {
        updateReview(app, {
          vehicleResult: res
        });
        addHistory(app, 'গাড়ির তথ্য যাচাই', res, res === 'যাচাইকৃত' ? 'green' : res === 'তথ্যের অমিল' ? 'red' : 'orange');
      }} data-id="element-694" data-mp="2p76osy4m4zp5" />
      </div>
    </div>;
}